import {
  createEvent,
  CreateEventMutation,
  CreateEventMutationVariables,
  DeleteEventMutationVariables,
  graphqlCall,
} from '@akin-home/amplify';
import { API } from 'aws-amplify';
import { UpdateEventInput } from '../types';

export const createEventMutation = (params: CreateEventMutationVariables) =>
  graphqlCall<CreateEventMutation>(createEvent, params);

export const updateEventMutation = (params: { input: UpdateEventInput }) =>
  API.put('CalendarAPI', `/events/${params.input?.id}`.replace('#', '%23'), {
    body: { input: params.input },
  });

export const deleteEventMutation = (params: DeleteEventMutationVariables) =>
  API.del('CalendarAPI', `/events/${params.input?.id}`.replace('#', '%23'), {});
